<template>
    <div class="col-md-4 col-md-offset-4 m-b-20 col-xs-12">
        <div class="title-form">
            <h1 @click="load = '200'">Send Email</h1>
            <span class="bigger" v-if="false"> </span>
        </div>
        <div>
        <div class="w-form">
            <form id="email-form" @submit.prevent="sendDataEmail"  name="email-form" data-name="Email Form">
                <flash-message></flash-message>
                <div class="field" title="Only enter a Send From email that you own">
                    <input type="email" name="email" title="Only enter a Send From email that you own" placeholder="name@example.com (email that you own)" v-model="form.from" class="input-form" required>
                    <label for="name">From Email</label>
                </div>
                <div class="field">
                    <input type="text" name="name" placeholder="Display name" v-model="form.name" class="input-form">
                    <label for="name">From Name</label>
                </div>
                <div class="field">
                    <input type="text" name="to" :placeholder="'{orbitly_email}'"  :value="'{orbitly_email}'" class="input-form" disabled>
                    <label for="to">To Email</label>
                </div>
                <div class="field">
                    <input type="email" name="cc" v-model="form.cc" placeholder="name@example.com" class="input-form">
                    <label for="cc">CC (optional)</label>
                </div>
                <div class="field">
                    <input type="text" name="subject" v-model="form.subject" placeholder="Subject line" class="input-form" required>
                    <label for="subject">Subject</label>
                </div>
                <div class="field snippet-field">
                    <select name="snippet" @change="insertSnippet(form.snippet)" v-model="form.snippet" class="input-form snippet-select">
                        <option value="">Insert magic snippet</option>
                        <option value="{orbitly_name}">{orbitly_name}</option>
                        <option value="{orbitly_first_name}">{orbitly_first_name}</option>
                        <option value="{orbitly_last_name}">{orbitly_last_name}</option>
                        <option value="{orbitly_email}">{orbitly_email}</option>
                        <option value="{orbitly_phone}">{orbitly_phone}</option>
                    </select>
                </div>
                <div class="field">
                    <textarea  class="input-form" name="body" v-model="body" rows="10" cols="100"  required>
                    </textarea>
                    <label for="password">Body</label>
                </div>
                <div class="form-medium-content">
                    <div class="content-left m-t-15">
                        <input type="button" id="loadFileXml" value="Attach a file" onclick="document.getElementById('file').click();" />
                        {{ file ? `${file.name.slice(0, 10)}...` : '' }}
                        <input type="file" style="display:none;" id="file" ref="file" @change="selectFile" value="Upload attachments"/>

                    </div>
                    <div class="content-right">
                        <input type="submit" value="Send Email" class="btn btn-small">
                    </div>
                </div>
            </form>
        </div>
        </div>
    </div>
</template>

<script>
export default {
  props: ['form', 'count_selected', 'amazonUrl', 'selected'],
  data () {
    return {
      file: false,
      body: `Hi, {orbitly_name}`
    }
  },
  methods: {
    // send email method
    selectFile: function () {
      this.file = this.$refs.file.files[0]
    },
    insertSnippet: function (snippet) {
      if (snippet.length) {
        this.body = `${this.body} ${this.form.snippet}`
        this.form.snippet = ''
      }
    },
    sendDataEmail: function () {
      this.$parent.setLoad('loading')
      var formData = new FormData()
      if (this.file) {
        formData.append('file', this.file)
      }
      formData.append('from', this.form.from)
      formData.append('name', this.form.name)
      formData.append('subject', this.form.subject)
      formData.append('cc', this.form.cc)
      formData.append('body', this.body)
      formData.append('s3_url', this.amazonUrl)
      formData.append('leads_selected', JSON.stringify(this.selected))
      this.$http.post('/api/leads/send_email', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        progress (e) {
          if (e.lengthComputable) {
            let _progress = Math.round(e.loaded / e.total * 100)
            console.log(_progress)
          }
        }
      }).then((res) => {
        this.$parent.setSend(true)
        this.$notify({
          group: 'foo',
          type: 'success',
          text: `${this.count_selected} emails successfully sent`,
          duration: 10000
        })
        this.$parent.setLoad('200')
        this.file = false
        this.$parent.setEmailSend(true)
        // this.email_send = true
        // this.$router.go(-1)
      }).catch((error) => {
        this.$parent.setLoad('200')
        this.$notify({
          group: 'foo',
          type: 'error',
          text: 'error trying to send email, please try again',
          duration: 10000
        })
        this.file = false
      })
    }
  }
}
</script>
